export function trackAddToCart() {
  if ((window as any).fbq) {
    ;(window as any).fbq('track', 'AddToCart', {
      content_name: 'Trading en Paz',
      content_type: 'product',
      value: 38000,
      currency: 'COP',
    })
  }
}

export function trackInitiateCheckout() {
  if ((window as any).fbq) {
    ;(window as any).fbq('track', 'InitiateCheckout', {
      content_name: 'Trading en Paz',
      content_type: 'product',
      value: 38000,
      currency: 'COP',
      num_items: 1,
    })
  }
}
